import { Controller } from "@hotwired/stimulus"

// Copies a URL and appends a server-rendered FlashComponent (flashHtml value).
// Optional trackUrl: POST after share to record analytics / timeline events.
export default class extends Controller {
  static values = {
    url: String,
    flashHtml: String,
    trackUrl: String
  }

  async share(event) {
    event.preventDefault()
    if (!this.urlValue) return

    await this.copyUrl()
    this.showCopiedFlash()
    this.trackShare()
  }

  async copyUrl() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = this.urlValue
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }
  }

  showCopiedFlash() {
    if (!this.hasFlashHtmlValue || this.flashHtmlValue.trim() === "") return

    const container = document.getElementById("flash")
    if (!container) return

    const wrapper = document.createElement("div")
    wrapper.innerHTML = this.flashHtmlValue.trim()
    const toast = wrapper.firstElementChild
    if (toast) container.appendChild(toast)
  }

  async trackShare() {
    if (!this.hasTrackUrlValue || !this.trackUrlValue) return

    try {
      const token = document.querySelector("meta[name='csrf-token']")?.content
      await fetch(this.trackUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token || "",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json"
        },
        credentials: "same-origin"
      })
    } catch (_error) {
      // tracking is best-effort
    }
  }
}
